var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2StoreRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 63v4H10v-4h56zm-5-28H36v4h25v-4zM38 59V42h21v17H38zm5-10h11v-3H43v3zm0 6h11v-3H43v3zM32 30c0-6.49-5-6.71-5-9.71V9h-4v11.31c0 3-5 3.22-5 9.71V59h14V30z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Store_room_bis.9d006b1b.svg";
export { SvgE2StoreRoomBis as ReactComponent };